import { forOwn } from '../../../lib/utilities';
import {ReduceStore} from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { Filters } from '../constants/filter/filters';
import { FilterAvailableOptionsActions } from '../constants/filter_available_options/filter_available_options_actions';

const filterOptions = [
    Filters.SPEED_INDEX,
    Filters.LOAD_INDEX,
];

class FilterAvailableOptionsStoreClass extends ReduceStore {
    getInitialState() {
        const initialFilterAvailableOptionsStoreState = {};

        filterOptions.forEach(filter => {
            initialFilterAvailableOptionsStoreState[filter] = [];
        });

        return initialFilterAvailableOptionsStoreState;
    }

    reduce(state, {source, action}) {
        let change = false;
        if (source === ACTION_TYPES.FILTER_AVAILBALE_OPTIONS_ACTION) {
            switch (action.type) {
                case FilterAvailableOptionsActions.UPDATE_FILTER_AVAILABLE_OPTIONS_ACTION:
                    forOwn(action.payload, (value, key) => {
                        if (typeof state[key] !== 'undefined') {
                            change = true;
                            state[key + 'Loading'] = false;
                            state[key] = value;
                        }
                    });

                    if (change) { this.__emitChange(); }
                    break;
            }
        }

        return state;
    }
}

const FilterAvailableOptionsStore = new FilterAvailableOptionsStoreClass(Dispatcher);
export { FilterAvailableOptionsStore };